// material-ui

import mountedforklift from '../../../assets/images/qualifications/mounted-forklift.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const MountedForklift = (props) => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={mountedforklift} alt="Mounted Forklift" height={props.height || 24} />
    );
};

export default MountedForklift;